/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Edit/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'
import ToothChartLetters from './ToothChartLetters/index'



/** @type {import('Simple/types.js').View} */
export default function Edit({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Images/ActiveTab/ToothChart/Content/Preview/Content/Edit"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ToothChartLetters'}>
<ToothChartLetters
  viewPath={`${viewPath}/ToothChartLetters`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}